import { render, staticRenderFns } from "./DistributionHistory.vue?vue&type=template&id=0166dd81&scoped=true&"
import script from "./DistributionHistory.vue?vue&type=script&lang=js&"
export * from "./DistributionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DistributionHistory.vue?vue&type=style&index=0&id=0166dd81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166dd81",
  null
  
)

export default component.exports